import { epoch, past, utc } from '../../util/datetime';
import {
  labeled,
  emailOptional,
  emailRequired,
  phoneCodeRequired,
  phoneNumberRequired,
  phoneCodeOptional,
  phoneNumberOptional,
  timeStampEpochRequired,
  enumRequired
} from '../../util/joi';
import { schema as preferredContactMethodSchema } from './ContactPreferredContactMethod.schema';
import { schema as addressSchema } from '../address/Address.schema';
import { auStatesTypes } from '../address/Address.enum';
import { contactResidentialStatusOptions } from './ContactResidentialStatusOption.enum';

export const schema = (Joi: any, label: string) =>
  Joi.object()
    .keys({
      primaryCode: phoneCodeRequired(Joi).label(labeled(label, 'Mobile prefix')),
      primary: phoneNumberRequired(Joi).label(labeled(label, 'Mobile number')),
      homeCode: phoneCodeOptional(Joi).label(labeled(label, 'Home prefix')),
      home: phoneNumberOptional(Joi).label(labeled(label, 'Home number')),
      workCode: phoneCodeOptional(Joi).label(labeled(label, 'Work prefix')),
      work: phoneNumberOptional(Joi).label(labeled(label, 'Work number')),
      email: emailRequired(Joi).label(labeled(label, 'Primary E-Mail address')),
      secondaryEmail: emailOptional(Joi).label(labeled(label, 'Secondary E-Mail address')),
      preferredContactMethod: preferredContactMethodSchema(Joi, label),
      address: addressSchema(Joi, labeled(label, 'Current address -')),
      housing: enumRequired(
        Joi,
        contactResidentialStatusOptions,
        labeled(label, 'Current address - Residential Status')
      ),
      from: timeStampEpochRequired(Joi).label(labeled(label, 'Current address - From')),
      previousAddress: Joi.any(),
      previousHousing: Joi.any(),
      previousFrom: Joi.any(),
      mailingAddress: addressSchema(Joi, labeled(label, 'Mailing address -')),
      settlementHousing: Joi.any().when('$isAssetFinance', {
        is: true,
        then: Joi.any(),
        otherwise: enumRequired(
          Joi,
          contactResidentialStatusOptions,
          labeled(label, 'Settlement address - Residential Status')
        )
      }),
      settlementAddress: Joi.any().when('$isAssetFinance', {
        is: true,
        then: Joi.any(),
        otherwise: addressSchema(Joi, labeled(label, 'Settlement address -'))
      })
    })
    .when(Joi.object({ from: Joi.number().greater(epoch(past(utc(), 'years', 3))) }), {
      then: Joi.object({
        previousAddress: addressSchema(Joi, labeled(label, 'Previous address -')),
        previousHousing: enumRequired(
          Joi,
          contactResidentialStatusOptions,
          labeled(label, 'Previous address - Residential Status')
        ),
        previousFrom: timeStampEpochRequired(Joi).label(
          labeled(label, 'Previous address - From')
        )
      })
    })
    .when('$auAddressOnly', {
      is: true,
      then: Joi.object().keys({
        settlementAddress: Joi.object().keys({
          country: Joi.string()
            .required()
            .valid('Australia')
            .messages({
              'any.only': '{#label} must be an Australian address'
            })
            .label(labeled(label, 'Settlement Address - Country')),
          state: Joi.string()
            .required()
            .valid(...auStatesTypes)
            .messages({
              'any.only': '{#label} must be an Australian state'
            })
            .label(labeled(label, 'Settlement Address - State'))
        }),
        mailingAddress: Joi.object().keys({
          country: Joi.string()
            .required()
            .valid('Australia')
            .messages({
              'any.only': '{#label} must be an Australian address'
            })
            .label(labeled(label, 'Mailing Address - Country')),
          state: Joi.string()
            .required()
            .valid(...auStatesTypes)
            .messages({
              'any.only': '{#label} must be an Australian state'
            })
            .label(labeled(label, 'Mailing Address - State'))
        })
      })
    });

export default {
  schema
};
